import { apiFetch } from './client';

interface ImpersonateResponse {
  message: string;
  targetUser: {
    userId: number;
    personId: number;
    name: string;
    role: string;
  };
}

export const impersonationApi = {
  start: (userId: number) =>
    apiFetch<ImpersonateResponse>(`/auth/impersonate/${userId}`, { method: 'POST' }),

  end: () =>
    apiFetch<{ message: string }>('/auth/endImpersonation', { method: 'POST' }),
};
